import React from 'react';
import { bonuses } from '../../data/kit';
export function BonusesSection() {
  return <section className="bg-teal py-14 sm:py-24" data-id="element-15" data-mp="15aj8j49asp6r">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-16" data-mp="15bb5ojijmuz5">
        <div className="mx-auto max-w-[820px] text-center" data-id="element-17" data-mp="qdirpvsnaen2">
          <span className="inline-block -rotate-2 rounded-md bg-coral px-4 py-1.5 font-display text-lg font-extrabold uppercase tracking-[.04em] text-white shadow-card" data-id="element-18" data-mp="qf3nfoqp43mi">
            + 5 Bonuses included
          </span>
          <h2 className="mt-5 font-display text-[40px] font-extrabold uppercase leading-[.95] text-white sm:text-[52px] lg:text-[58px]" data-id="element-19" data-mp="1o07zkma13lgu">
            Five bonuses for the rest of your week
          </h2>
          <p className="mt-5 text-base leading-relaxed text-mint sm:text-[17px]" data-id="element-20" data-mp="1ea6bhuhoe31x">
            Every bonus is a printable PDF, included with your purchase.
          </p>
        </div>
        <ul className="mt-10 grid gap-4 sm:mt-12 sm:flex sm:flex-wrap sm:justify-center sm:gap-5" data-id="element-21" data-mp="26qz49aj2mnow">
          {bonuses.map((bonus, i) => {
          const number = String(i + 1).padStart(2, '0');
          return <li key={bonus.title} className="grid grid-cols-[112px_1fr] overflow-hidden rounded-2xl bg-cream shadow-card sm:flex sm:w-[calc(50%-10px)] sm:flex-col lg:w-[calc(33.333%-14px)]" data-id="element-22" data-mp="2h6xmx9hr11x7" data-mpi={i}>
                <div className="relative bg-mint" data-id="element-23" data-mp="2r30mq8p4oogz">
                  <img src={bonus.cover} alt={`Cover of ${bonus.title}`} width={1024} height={1024} loading="lazy" className="h-full w-full object-cover sm:aspect-square sm:h-auto" data-id="element-24" data-mp="34vgwdscjbkqv" />
                  <span className="absolute left-2 top-2 rounded-md bg-coral px-2 py-1 text-[10px] font-bold uppercase tracking-[.12em] text-white sm:left-4 sm:top-4 sm:text-[11px]" data-id="element-25" data-mp="39w4nsf4oe3lm">
                    Bonus {number}
                  </span>
                </div>
                <div className="flex flex-1 flex-col justify-center p-4 sm:justify-start sm:p-6" data-id="element-26" data-mp="2557j9ugjau3v">
                  <h3 className="font-display text-[21px] font-extrabold uppercase leading-[.95] text-petrol sm:text-[28px]" data-id="element-27" data-mp="296swxi0w7cf4">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate sm:mt-3 sm:text-[15px]" data-id="element-28" data-mp="2e88mnne0m73u">{bonus.benefit}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}